// src/components/SearchSuggestions.ts
import "./SearchSuggestions.css";

/* ============================================================
   RENDER HTML STRING
============================================================ */
export function renderSearchSuggestions(query: string): string {
  if (!query.trim()) return "";

  const suggestions = [
    `${query} news`,
    `${query} images`,
    `${query} videos`,
    `${query} price`,
    `${query} wiki`,
  ];

  return `
    <div class="suggestions-container">
      ${suggestions
        .map(
          (s) => `
        <div class="suggestion-item" data-value="${s}">
          <span class="suggestion-icon">🔍</span>
          <span>${s}</span>
        </div>
      `,
        )
        .join("")}
    </div>
  `;
}

/* ============================================================
   EVENT INITIALIZER
============================================================ */
export function initSearchSuggestionsEvents(
  container: HTMLElement,
  onSelect: (value: string) => void,
): void {
  const items = container.querySelectorAll(".suggestion-item");

  items.forEach((item) => {
    item.addEventListener("click", () => {
      const value = item.getAttribute("data-value");
      if (value) onSelect(value);
    });
  });
}
